import {arrayMove} from 'react-sortable-hoc';
import firstBy from 'thenby';

import * as types from './actionTypes';

const initialSearch = {
  petTypes: [],
  results: [],
  phrase: '',
  selectedPetTypes: []
};

const initialState = {
  list: [],
  
  grid: {
    isSorting: false
  },

  petLabels: [],
  petLabelsValid: false,

  search: initialSearch,
  
  selected: {
    gridIndex: -1,
    petLabelId: -1,
    articleMappingId: -1
  },

  active: {
    petLabel: {}
  },

  definitions: [],
  definitionsValid: false,
  
  customDefinitions: [],
  selectedCustomType: '',

  activeSize: '',
  activePLU: false,

  pdfId: '0',

  articles: [],
  articlesValid: false,
  shownArticles: [],
  articleSortColumn: null,
  articleSortDirection: '',
  articleFilters: {},

  calibrationLink: '',

  labelModalOpen: false,
  labelAddEnabled: true
};

export default function reducer(state = initialState, action = {}) {
  switch(action.type) {
    case types.SET_GRID_SORTING: {
      return {
        ...state,
        grid: {
          ...state.grid,
          isSorting: action.payload.isSorting
        }
      };
    }
    case types.SET_LABEL_INDEX: {
      const {oldIndex, newIndex} = action.payload;
      let list = arrayMove(state.list, oldIndex, newIndex);
      return {
        ...state,
        list
      };
    }
    case types.SELECT_LABEL: {
      return {
        ...state,
        selected: {
          ...state.selected,
          gridIndex: action.payload.index
        }
      };
    }
    case types.PET_LABEL_LIST_RECEIVED: {
      return {
        ...state,
        petLabels: action.payload.petLabels,
        petLabelsValid: true
      };
    }
    case types.PET_LABEL_LIST_RELOAD: {
      let li = action.payload.isValid;

      return {
        ...state,
        petLabelsValid: li
      };
    }

    case types.PET_LABEL_PRICE_UPDATE: {
      let labelIndex = -1;
      let newArticles = [...state.petLabels];
      newArticles.find((petLabel, index) => {
        if (petLabel.Id === action.payload.label.Id && petLabel.ArticleMappingEntryID === action.payload.label.ArticleMappingEntryID) {
          return labelIndex = index;
        }
      });
      
      //state.petLabels.slice(0);
      let newpet = JSON.parse(JSON.stringify(action.payload.label));
      newpet.Price = action.payload.price;
      newArticles[labelIndex] = newpet;
      
      return {
        ...state,
        petLabels: newArticles
      };
    }


    case types.PET_TYPES_ADDED: {
      return {
        ...state,
        search: {
          ...state.search,
          petTypes: action.payload.petTypes,
          selectedPetTypes: action.payload.selectedPetTypes
        }
      };
    }
    case types.TOGGLE_SELECTED_PET_TYPE: {
      let selectedPetTypes = [...state.search.selectedPetTypes];
      const togglePetType = action.payload.petType;
      
      let found = selectedPetTypes.find((petType) => {
        return petType === togglePetType;
      });
      
      if(found) {
        let index = selectedPetTypes.indexOf(togglePetType);
        selectedPetTypes.splice(index, 1);
      } else {
        selectedPetTypes.push(togglePetType);
      }

      return {
        ...state,
        search: {
          ...state.search,
          selectedPetTypes: selectedPetTypes
        }
      };
    }
    case types.LABELS_SEARCH_PHRASE: {
      let searchPhrase = '';
      if(action.payload.searchPhrase !== undefined) {
        searchPhrase = action.payload.searchPhrase.toLowerCase();
      } else {
        searchPhrase = '';
      }

      return {
        ...state,
        search: {
          ...state.search,
          phrase: searchPhrase
        }
      };
    }
    case types.CLEAR_SEARCH_RESULTS: {
      return {
        ...state,
        search: {
          ...state.search,
          results: [],
          phrase: '',
          selectedPetType: state.search.petTypes
        }
      };
    }
    case types.FILTER_PET_LABELS: {
      const searchPhrase = state.search.phrase;
      
      const searchAllTypes = (state.search.petTypes.length === state.search.selectedPetTypes.length || 
                         state.search.selectedPetTypes.length === 0) ? true : false;

      let searchResults = state.petLabels.filter((petLabel) => {
        if(searchAllTypes) {    
          return (petLabel.Line1 !== null && petLabel.Line1.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (petLabel.Line2 !== null && petLabel.Line2.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (petLabel.Line3 !== null && petLabel.Line3.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (petLabel.Line4 !== null && petLabel.Line4.toLowerCase().indexOf(searchPhrase) >= 0);
        } else {
          return (state.search.selectedPetTypes.includes(petLabel.PetType)) && (
                 (petLabel.Line1 !== null && petLabel.Line1.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (petLabel.Line2 !== null && petLabel.Line2.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (petLabel.Line3 !== null && petLabel.Line3.toLowerCase().indexOf(searchPhrase) >= 0) ||
                 (petLabel.Line4 !== null && petLabel.Line4.toLowerCase().indexOf(searchPhrase) >= 0));
        }
      });

      searchResults.sort(firstBy("Line1")
                         .thenBy("Line2"));

      return {
        ...state,
        search: {
          ...state.search,
          results: searchResults
        }
      };
    }
    case types.SELECT_PET_LABEL: {
      return {
        ...state,
        selected: {
          ...state.selected,
          petLabelId: action.payload.petLabelId,
          articleMappingId: action.payload.articleMappingId
        }
      };
    }
    case types.DESELECT_PET_LABEL: {
      return {
        ...state,
        selected: {
          ...state.selected,
          petLabelId: -1,
          articleMappingId: -1
        }
      };
    }
    case types.PET_LABEL_RECEIVED: {
      return {
        ...state,
        active: {
          ...state.active,
          petLabel: action.payload.petLabel
        }
      };
    }
    case types.CLEAR_ACTIVE_LABEL: {
      return {
        ...state,
        active: {
          ...state.active,
          petLabel: {}
        }
      };
    }
    case types.LABEL_DEFINITIONS_RECEIVED: {
      return {
        ...state,
        definitions: action.payload.definitions, 
        definitionsValid: true,
        styleElements: action.payload.definitions[0].StyleElements
      };
    }
    case types.SELECT_LABEL_SIZE: {
      const labelList = createLabelList(state, action.payload.labelSize);
      return {
        ...state,
        activeSize: action.payload.labelSize,
        list: labelList,
        pdfId: action.payload.pdfId
      };
    }
    case types.SAVE_LABEL_TO_SHEET: {
      let labels = JSON.parse(JSON.stringify(state.list));
      labels[state.selected.gridIndex] = {imageUrl: action.payload.imageUrl, data: action.payload.label};
      return {
        ...state,
        list: labels
      };  
    }
    case types.CLEAR_LABEL_SHEET: {
      const labelList = createLabelList(state, state.activeSize);
      return {
        ...state,
        list: labelList
      };
    }
    case types.TOGGLE_PLU_ACTIVE: {
      return {
        ...state,
        activePLU: !state.activePLU
      };
    }
    case types.DELETE_LABEL_FROM_SHEET: {
      let labels = JSON.parse(JSON.stringify(state.list));
      labels[action.payload.gridIndex] = {};
      return {
        ...state,
        list: labels
      };
    }
    case types.EDIT_EXISTING_LABEL: {
      let label = state.list[action.payload.gridIndex].data;
      return {
        ...state,
        selected: {
          ...state.selected,
          gridIndex: action.payload.gridIndex
        },
        active: {
          ...state.active,
          petLabel: label
        }
      };
    }
    case types.CUSTOM_DEFINITIONS_RECEIVED: {
      return {
        ...state,
        customDefinitions: action.payload.definitions
      };
    }
    case types.SELECT_CUSTOM_LABEL: {
      return {
        ...state,
        selectedCustomType: action.payload.petType,
        active: {
          ...state.active,
          petLabel: state.customDefinitions[action.payload.petType]
        }
      };
    }
    case types.ARTICLE_LIST_RECEIVED: {

      // TODO: need to apply the filters here

      let newShownArticles = action.payload.petLabels.slice(0);
      let shownArticles = [];
      if(state.articleSortColumn !== null) {
        shownArticles = sortArticleList(state, newShownArticles, state.articleSortColumn, state.articleSortDirection);
      } else {
        shownArticles = sortArticleList(state, newShownArticles, 'Line1', 'ASC');
      }

      return {
        ...state,
        articles: action.payload.petLabels,
        articlesValid: true,
        articleSortColumn: 'Line1',
        articleSortDirection: 'ASC',
        shownArticles: shownArticles,
      };
    }
    case types.UPDATE_LABEL_ARTICLE: {
      let labelIndex = -1;
      state.articles.find((petLabel, index) => {
        if (petLabel.Id === action.payload.label.Id && petLabel.ArticleMappingEntryID === action.payload.label.ArticleMappingEntryID) {
          return labelIndex = index;
        }
      });
      
      let newArticles = state.articles.slice(0);
      newArticles[labelIndex] = action.payload.label;

      let newShownArticles = newArticles.slice(0);

      let filterArticles = filterArticleList(state, newShownArticles, state.articleFilters);

      let shownArticles = [];
      if(state.articleSortColumn !== null) {
        shownArticles = sortArticleList(state, filterArticles, state.articleSortColumn, state.articleSortDirection);
      } else {
        shownArticles = newShownArticles;
      }
      
      return {
        ...state,
        articles: newArticles,
        shownArticles: shownArticles
      };
    }
    case types.SORT_ARTICLE_COLUMN: {
      const sortColumn = action.payload.sortColumn;
      const sortDirection = action.payload.sortDirection;

      let filterArticles = filterArticleList(state, state.shownArticles, state.articleFilters);
      let articleList = sortArticleList(state, filterArticles, action.payload.sortColumn, action.payload.sortDirection);

      return {
        ...state,
        shownArticles: articleList,
        articleSortColumn: sortColumn,
        articleSortDirection: sortDirection
      };
    }
    case types.CLEAR_ARTICLE_FILTERS: {
      let articleList = state.articles.slice(0);
      let shownArticles = [];
      if(state.articleSortColumn !== null) {
        let newShownArticles = articleList.slice(0);
        shownArticles = sortArticleList(state, newShownArticles, state.articleSortColumn, state.articleSortDirection);
      } else {
        shownArticles = articleList.slice(0);
      }
      
      return {
        ...state,
        shownArticles: shownArticles,
        filters: []
      };
    }
    case types.CALIBRATION_PDF_LINK: {
      return {
        ...state,
        calibrationLink: action.payload.link
      };
    }
    case types.ADD_ARTICLE_MAPPING: {
      let articleList = state.articles.slice(0);
      articleList.push(action.payload.article);

      let filterArticles = filterArticleList(state, articleList, state.articleFilters);

      let shownArticles = [];
      if(state.articleSortColumn !== null) {
        let newShownArticles = filterArticles.slice(0);
        shownArticles = sortArticleList(state, newShownArticles, state.articleSortColumn, state.articleSortDirection);
      } else {
        shownArticles = articleList.slice(0);
      }

      return {
        ...state,
        articles: articleList,
        shownArticles: shownArticles
      };
    }
    case types.DELETE_ARTICLE_MAPPING: {
      let articleList = state.articles.slice(0);
      let index = articleList.indexOf(action.payload.article);
      if(index > -1) {
        articleList.splice(index, 1);
      }

      if(action.payload.article.ArticleMappingEntryID === 0) {
        let article = JSON.parse(JSON.stringify(action.payload.article));
        article.CustomerName = '';
        article.Price = '';
        article.PLUCode = '';
        articleList.push(article);
      }

      let filterArticles = filterArticleList(state, articleList, state.articleFilters);
      
      let shownArticles = [];
      if(state.articleSortColumn !== null) {
        let newShownArticles = filterArticles.slice(0);
        shownArticles = sortArticleList(state, newShownArticles, state.articleSortColumn, state.articleSortDirection);
      } else {
        shownArticles = articleList.slice(0);
      }

      return {
        ...state,
        articles: articleList,
        shownArticles: shownArticles
      };
    }
    case types.SHOW_LABEL_MODAL: {
      return {
        ...state,
        labelModalOpen: true
      };
    }
    case types.HIDE_LABEL_MODAL: {
      return {
        ...state,
        labelModalOpen: false
      };
    }
    case types.DISABLE_LABEL_ADD: {
      return {
        ...state,
        labelAddEnabled: false
      };
    }
    case types.ENABLE_LABEL_ADD: {
      return {
        ...state,
        labelAddEnabled: true
      };
    }
    case types.SELECT_NEXT_LABEL: {
      let nextIndex = 0;
      state.list.find((label) => {
        if(Object.keys(label).length === 0) {
          return label;
        }
        nextIndex++;
      });

      return {
        ...state,
        selected: {
          ...state.selected,
          gridIndex: nextIndex
        }
      };
    }
    case types.ADD_ARTICLE_FILTER: {
      let filters = JSON.parse(JSON.stringify(state.articleFilters));
      filters[action.payload.column] = action.payload.value;
      
      let filteredArticles = filterArticleList(state, state.articles.slice(0), filters);
      let shownArticles = sortArticleList(state, filteredArticles, state.articleSortColumn, state.articleSortDirection);

      return {
        ...state,
        articleFilters: filters,
        shownArticles: shownArticles
      };
    }
    default:
      return state;
  }
}

function createLabelList(state, labelSize) {
  const selectedLabel = state.definitions.find((label) => {
    return label.LabelName === labelSize;
  });
  let labelList = new Array(selectedLabel.LabelPositions.length);
  labelList.fill({}, 0, selectedLabel.LabelPositions.length);
  return labelList;
}

function sortArticleList(state, articles, sortColumn, sortDirection) {
  let articleList = articles.slice(0);
  let list = [];
  if(sortDirection !== 'NONE') {
    list = articleList.sort((a, b) => {
      if(sortDirection === 'ASC') {
        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
      } else if(sortDirection === 'DESC') {
        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
      } 
    });
  } else {
    list = articles.slice(0);
  }
  return list;
}

function filterArticleList(state, articles, filters) {
  let articleList = articles.slice(0);
  
  if(filters['Id'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.Id.toString().includes(filters['Id']);
    });  
  }

  if(filters['Line1'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.Line1.toLowerCase().includes(filters['Line1'].toLowerCase());
    });
  }

  if(filters['Line2'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.Line2.toLowerCase().includes(filters['Line2'].toLowerCase());
    });
  }

  if(filters['PetType'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.PetType.toLowerCase().includes(filters['PetType'].toLowerCase());
    });
  }

  if(filters['CustomerName'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.CustomerName.toLowerCase().includes(filters['CustomerName'].toLowerCase());
    });
  }

  if(filters['Price'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.Price.toLowerCase().includes(filters['Price'].toLowerCase());
    });
  }

  if(filters['Barcode'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.Barcode.toLowerCase().includes(filters['Barcode'].toLowerCase());
    });
  }

  if(filters['PLUCode'] !== undefined) {
    articleList = articleList.filter((article) => {
      return article.PLUCode.toLowerCase().includes(filters['PLUCode'].toLowerCase());
    });
  }

  return articleList;
}


/** WEBPACK FOOTER **
 ** ./src/modules/labels/reducer.js
 **/